<div
  [formGroup]="form"
  class="purchase-order-shipments-filters flex gap-4 align-center"
>
  <div>
    <label class="lum-label filter-label">Order #</label>
    <input
      (debounceValue)="onFilterChange($event, 'supplierPurchaseOrderId')"
      type="text"
      class="lum-input"
      lumDebounceTime
      [debounceTime]="500"
      formControlName="supplierPurchaseOrderId"
    />
  </div>

  <div>
    <label class="lum-label filter-label">Status</label>
    <mat-select
      [value]="currentQueryParams?.shipmentStatusId || ''"
      (selectionChange)="onFilterChange($event.value, 'shipmentStatusId')"
      class="lum-input"
      formControlName="shipmentStatusId"
    >
      <mat-option [value]="''">All</mat-option>
      <mat-option
        *ngFor="let status of shipmentStatus$ | async; trackBy: trackById"
        [value]="status?.id"
        >{{ status?.name }}</mat-option
      >
    </mat-select>
  </div>

  <div *ngIf="'UTAH-248-recount_incoming_with_shipments' | featureFlag">
    <label class="lum-label filter-label">Warehouse</label>
    <mat-select
      [value]="currentQueryParams?.warehouseId || ''"
      (selectionChange)="onFilterChange($event.value, 'warehouseId')"
      class="lum-input"
      formControlName="warehouseId"
    >
      <mat-option [value]="''">All</mat-option>
      <mat-option
        *ngFor="let warehouse of warehouses; trackBy: trackById"
        [value]="warehouse?.id"
        >{{ warehouse?.location_name }}</mat-option
      >
    </mat-select>
  </div>

  <div>
    <label class="lum-label filter-label">Shipment Date </label>
    <div class="flex gap-2">
      <!-- TODO: Create own component date picker -->
      <div class="date-picker-container">
        <input
          class="lum-input w-45"
          formControlName="shippingDateStart"
          [matDatepicker]="shipmentDateStartPicker"
          (dateChange)="onFilterChange($event.value, 'shippingDateStart')"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="shipmentDateStartPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #shipmentDateStartPicker></mat-datepicker>
      </div>

      <div class="date-picker-container">
        <input
          class="lum-input w-45"
          formControlName="shippingDateEnd"
          [matDatepicker]="shipmentDateEndPicker"
          [disabled]="!form.controls['shippingDateStart'].value"
          (dateChange)="onFilterChange($event.value, 'shippingDateEnd')"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="shipmentDateEndPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #shipmentDateEndPicker></mat-datepicker>
      </div>
    </div>
  </div>
  <button
    (click)="onResetFilters()"
    class="lum-button mt-4"
    color="warn"
    aria-label="remove icon"
  >
    Reset
  </button>
</div>
